import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Define a styled component for the gallery button
const GalleryButton = styled(Link)`
  display: inline-block;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.highlight};
  border: 2px solid ${({ theme }) => theme.colors.highlight};
  padding: 1rem 2rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  margin: 0 1rem;
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.highlight};
    color: white;
    transform: translateY(-2px);
  }
`;

const Container = styled.div`
  padding: 2rem;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.highlight};
  margin-bottom: 2rem;
  font-size: 2.5rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.colors.light};
`;

const CtaButton = styled(Link)`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.highlight};
  color: white;
  padding: 1rem 2rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  margin: 0 1rem;
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.accent};
    transform: translateY(-2px);
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

const BetaBanner = styled.div`
  margin-top: 3rem;
  padding: 1.5rem 2rem;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid ${({ theme }) => theme.colors.highlight};
  color: ${({ theme }) => theme.colors.light};
  text-align: left;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;

  h2 {
    margin: 0 0 0.5rem;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.highlight};
  }

  p {
    margin: 0 0 1rem;
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;

const BetaButton = styled(Link)`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.highlight};
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent};
    transform: translateY(-1px);
  }
`;

const Home = () => {
  return (
    <Container>
      <Title>Welcome to Sonna</Title>
      <Subtitle>
        Book your next tattoo appointment with Sonna, your studio's simple, artist-first scheduling system.
        Browse artists, view portfolios, and send clear booking requests all in one place.
      </Subtitle>
      <ButtonGroup>
        <CtaButton to="/booking">Book Now</CtaButton>
        <GalleryButton to="/gallery">
          View Gallery
        </GalleryButton>
      </ButtonGroup>
      <BetaBanner>
        <h2>Join the Sonna beta</h2>
        <p>
          We're inviting a small group of artists to help shape Sonna before we launch publicly. Get early access to
          the AI assistant, booking tools, and onboarding support in exchange for your feedback.
        </p>
        <BetaButton to="/register">Apply for beta access</BetaButton>
      </BetaBanner>
    </Container>
  );
};

export default Home;
